import React from "react";

const GenericPage = () => {
  return <div>Coming Soon {window.location.pathname}</div>;
};

export default GenericPage;
